import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchSubscriptionUrlByEventId = async (token, eventId) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);

  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  let service_type = "Wordly";
  if(eventId === 67 || eventId === 79) {
    service_type = "Wordly";
  }else if(eventId === 134){
    service_type = "SpellingBee";
  }else if(eventId === 151){
    service_type = "MemoryMatch";
  }
  const res = await axios
    .post(
      `${baseUrl}/wordly/subscription/create/`,
      { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": service_type, ...paramsObject },
      config
    )
  return res.data;
}